export const NODE_HEIGHT = 20;
export const NODE_WIDTH = 40;
export const INPUT = 'INPUT';
export const OUTPUT = 'OUTPUT';
export const NODE_COLOR = 'black';
export const MODULATOR_COLOR = '#3837374f';
export const WIDTH=600;
export const HEIGHT=400;

export const NODE_HEIGHTS = {
    AUDIO_FX: 20,
    LIVE_FX: 20,
    MIDI_FX: 20,
    OSCILLATOR: 26,
};

export const FONT_SIZES= {
    AUDIO_FX: 10,
    LIVE_FX: 10,
    MIDI_FX: 10,
    OSCILLATOR: 14,
};



export const WIDTHS = {
    AUDIO_FX: WIDTH,
    LIVE_FX: WIDTH,
    MIDI_FX: WIDTH,
    OSCILLATOR: 200,
};
